import React from 'react';

const ModalComponent = ({ open, onClose, title, content, additionalInfo }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h3>{title}</h3>
        <ul className="modal-content-list">
          {content.map((item, index) => (
            <li key={index} className="modal-content-item">
              <i className="fa-solid fa-check" style={{ color: 'green' }}></i>
              {item}
            </li>
          ))}
        </ul>
        {additionalInfo && (
          <div className="modal-additional-info">
            <h4>For more information:</h4>
            <p>{additionalInfo}</p>
          </div>
        )}
        <button className="modal-footer-button" onClick={onClose}>
          I UNDERSTAND
        </button>
      </div>
    </div>
  );
};

export default ModalComponent;
